"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[822],{

/***/ 9432:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Footer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _services_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8382);



function Footer(param) {
    let { company  } = param;
    const [businessHours, setBusinessHours] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [activeMenu, setActiveMenu] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [active, setActive] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const handleChange = (menu)=>{
        setActiveMenu(activeMenu === menu ? null : menu);
    };
    const showHours = ()=>{
        setActive((prev)=>!prev);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const fetchBusinessHours = async ()=>{
            const hours = [];
            try {
                const res = await (0,_services_api__WEBPACK_IMPORTED_MODULE_2__/* .fetchGetCompanyBusinessHours */ .Ez)();
                if (res.monday && res.tuesday && res.wednesday && res.thursday && res.friday) {
                    const sameWeekdayHours = res.mondayOpeningTime === res.tuesdayOpeningTime && res.mondayOpeningTime === res.wednesdayOpeningTime && res.mondayOpeningTime === res.thursdayOpeningTime && res.mondayOpeningTime === res.fridayOpeningTime && res.mondayClosingTime === res.tuesdayClosingTime && res.mondayClosingTime === res.wednesdayClosingTime && res.mondayClosingTime === res.thursdayClosingTime && res.mondayClosingTime === res.fridayClosingTime;
                    if (sameWeekdayHours) {
                        hours.push({
                            name: "Segunda \xe0 Sexta",
                            openingTime: res.mondayOpeningTime.slice(0, 5),
                            closingTime: res.mondayClosingTime.slice(0, 5)
                        });
                    } else {
                        if (res.monday) {
                            hours.push({
                                name: "Segunda-feira",
                                openingTime: res.mondayOpeningTime.slice(0, 5),
                                closingTime: res.mondayClosingTime.slice(0, 5)
                            });
                        }
                        if (res.tuesday) {
                            hours.push({
                                name: "Ter\xe7a-feira",
                                openingTime: res.tuesdayOpeningTime.slice(0, 5),
                                closingTime: res.tuesdayClosingTime.slice(0, 5)
                            });
                        }
                        if (res.wednesday) {
                            hours.push({
                                name: "Quarta-feira",
                                openingTime: res.wednesdayOpeningTime.slice(0, 5),
                                closingTime: res.wednesdayClosingTime.slice(0, 5)
                            });
                        }
                        if (res.thursday) {
                            hours.push({
                                name: "Quinta-feira",
                                openingTime: res.thursdayOpeningTime.slice(0, 5),
                                closingTime: res.thursdayClosingTime.slice(0, 5)
                            });
                        }
                        if (res.friday) {
                            hours.push({
                                name: "Sexta-feira",
                                openingTime: res.fridayOpeningTime.slice(0, 5),
                                closingTime: res.fridayClosingTime.slice(0, 5)
                            });
                        }
                    }
                }
                if (res.saturday) {
                    hours.push({
                        name: "S\xe1bado",
                        openingTime: res.saturdayOpeningTime.slice(0, 5),
                        closingTime: res.saturdayClosingTime.slice(0, 5)
                    });
                }
                if (res.sunday) {
                    hours.push({
                        name: "Domingo",
                        openingTime: res.sundayOpeningTime.slice(0, 5),
                        closingTime: res.sundayClosingTime.slice(0, 5)
                    });
                }
                if (res.holiday) {
                    hours.push({
                        name: "Feriado",
                        openingTime: res.holidayOpeningTime.slice(0, 5),
                        closingTime: res.holidayClosingTime.slice(0, 5)
                    });
                }
                setBusinessHours(hours);
            } catch (error) {
                console.error("Erro ao buscar os hor\xe1rios de funcionamento:", error);
            }
        };
        fetchBusinessHours();
    }, []);
    const [vehiclePages, setVehiclePages] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [servicesPages, setServicesPages] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const vehiclePages = [];
        const servicesPages = [];
        (0,_services_api__WEBPACK_IMPORTED_MODULE_2__/* .fetchGetCompanySiteSettings */ .XQ)().then((res)=>{
            res.showNew === true ? vehiclePages.push({
                route: "novos",
                name: "0 Km"
            }) : null;
            res.showUsed === true ? vehiclePages.push({
                route: "seminovos",
                name: "Seminovos"
            }) : null;
            res.showArmored === true ? vehiclePages.push({
                route: "blindados",
                name: "Blindados"
            }) : null;
            res.showInsurance === true ? servicesPages.push({
                route: "seguro",
                name: "Seguro"
            }) : null;
            res.showFinancing === true ? servicesPages.push({
                route: "financiamento",
                name: "Financiamento"
            }) : null;
            res.showVehiclePurchase === true ? servicesPages.push({
                route: "venda-seu-veiculo",
                name: "Venda seu Ve\xedculo"
            }) : null;
            setVehiclePages(vehiclePages);
            setServicesPages(servicesPages);
        });
    }, []);
    const cnpjMask = (number)=>{
        number.replace(/\D/g, "");
        return number.replace(/^(\d{2})(\d{3})?(\d{3})?(\d{4})?(\d{2})?/, "$1. $2. $3/$4-$5");
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("footer", {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "footer-wrapper position-relative z-1",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "footer-copyright",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "visible",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "d-flex justify-content-around align-items-center p-4",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "d-flex flex-direction-column justify-content-around align-items-center company-contacts",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "d-flex gap-4",
                                            children: [
                                                company.facebook ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    href: company.facebook,
                                                    target: "_blank",
                                                    rel: "noreferrer",
                                                    "aria-label": "Acesse o facebook da nossa loja",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "social-background",
                                                        children: company.facebook ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                                className: "fab fa-facebook-f"
                                                            })
                                                        }) : null
                                                    })
                                                }) : null,
                                                company.instagram ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    href: company.instagram,
                                                    target: "_blank",
                                                    rel: "noreferrer",
                                                    "aria-label": "Acesse o instagram da nossa loja",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "social-background",
                                                        children: company.instagram ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                                className: "fab fa-instagram"
                                                            })
                                                        }) : null
                                                    })
                                                }) : null,
                                                company.youtube ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    href: company.youtube,
                                                    target: "_blank",
                                                    rel: "noreferrer",
                                                    "aria-label": "Acesse o youtube da nossa loja",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "social-background",
                                                        children: company.youtube ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                                className: "fab fa-youtube"
                                                            })
                                                        }) : null
                                                    })
                                                }) : null,
                                                company.tiktok ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    href: company.tiktok,
                                                    target: "_blank",
                                                    rel: "noreferrer",
                                                    "aria-label": "Acesse o tiktok da nossa loja",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "social-background",
                                                        children: company.tiktok ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                                className: "fab fa-tiktok"
                                                            })
                                                        }) : null
                                                    })
                                                }) : null
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "footer-separator",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {}),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                            className: "fas fa-diamond mx-3"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {})
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "d-flex align-items-center quick-link-box",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "col-lg-12 d-flex flex-wrap",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "border-sm col-lg-9 col-sm-12 d-flex flex-wrap",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "quick-links col-lg-3 col-md-6",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: "d-flex justify-content-start align-items-center gap-2",
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        className: "quick-link-icon",
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                                            className: "flaticon-speedometer"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                        className: "mb-0 white",
                                                                        children: "VE\xcdCULOS"
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        className: "d-none arrow-down ".concat(activeMenu === "vehicles" ? "rotate" : null),
                                                                        onClick: ()=>handleChange("vehicles"),
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                                                            xmlns: "http://www.w3.org/2000/svg",
                                                                            width: "24",
                                                                            height: "24",
                                                                            viewBox: "0 0 24 24",
                                                                            fill: "none",
                                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                                                d: "M4 8L12 16L20 8",
                                                                                stroke: "currentColor",
                                                                                "stroke-width": "3.5",
                                                                                "stroke-linecap": "round",
                                                                                "stroke-linejoin": "round"
                                                                            })
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "mobile-pages ".concat(activeMenu === "vehicles" ? "open" : ""),
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                                                    children: vehiclePages.map((page, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                            href: "/".concat(page.route),
                                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                                className: "white",
                                                                                children: page.name
                                                                            })
                                                                        }, index))
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "quick-links col-lg-3 col-md-6",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: "d-flex justify-content-start align-items-center gap-2",
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        className: "quick-link-icon",
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                                            className: "flaticon-shield"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                        className: "mb-0 white",
                                                                        children: "SERVI\xc7OS"
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        className: "d-none arrow-down ".concat(activeMenu === "services" ? "rotate" : null),
                                                                        onClick: ()=>handleChange("services"),
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                                                            xmlns: "http://www.w3.org/2000/svg",
                                                                            width: "24",
                                                                            height: "24",
                                                                            viewBox: "0 0 24 24",
                                                                            fill: "none",
                                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                                                d: "M4 8L12 16L20 8",
                                                                                stroke: "currentColor",
                                                                                "stroke-width": "3.5",
                                                                                "stroke-linecap": "round",
                                                                                "stroke-linejoin": "round"
                                                                            })
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "mobile-pages ".concat(activeMenu === "services" ? "open" : ""),
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                                                    children: servicesPages.map((page, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                            href: "/".concat(page.route),
                                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                                className: "white",
                                                                                children: page.name
                                                                            })
                                                                        }, index))
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "quick-links col-lg-3 col-md-6",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: "d-flex justify-content-start align-items-center gap-2",
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        className: "quick-link-icon",
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                                            className: "flaticon-info"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                        className: "mb-0 white",
                                                                        children: "INSTITUCIONAL"
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        className: "d-none arrow-down ".concat(activeMenu === "institutional" ? "rotate" : null),
                                                                        onClick: ()=>handleChange("institutional"),
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                                                            xmlns: "http://www.w3.org/2000/svg",
                                                                            width: "24",
                                                                            height: "24",
                                                                            viewBox: "0 0 24 24",
                                                                            fill: "none",
                                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                                                d: "M4 8L12 16L20 8",
                                                                                stroke: "currentColor",
                                                                                "stroke-width": "3.5",
                                                                                "stroke-linecap": "round",
                                                                                "stroke-linejoin": "round"
                                                                            })
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "mobile-pages ".concat(activeMenu === "institutional" ? "open" : ""),
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                            href: "/sobre-nos",
                                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                                className: "white",
                                                                                children: "Sobre N\xf3s"
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                            href: "/sobre-nos",
                                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                                className: "white",
                                                                                children: "Nossa Vis\xe3o"
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                            href: "/sobre-nos",
                                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                                className: "white",
                                                                                children: "Nossos Valores"
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                            href: "/sobre-nos",
                                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                                className: "white",
                                                                                children: "Nossa Miss\xe3o"
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "quick-links col-lg-3 col-md-6 quick-links col-lg-3 separator",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: "d-flex justify-content-start align-items-center gap-2",
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        className: "quick-link-icon",
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                                            className: "flaticon-headphones"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                        className: "mb-0 white",
                                                                        children: "ATENDIMENTO"
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        className: "d-none arrow-down ".concat(activeMenu === "support" ? "rotate" : null),
                                                                        onClick: ()=>handleChange("support"),
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                                                            xmlns: "http://www.w3.org/2000/svg",
                                                                            width: "24",
                                                                            height: "24",
                                                                            viewBox: "0 0 24 24",
                                                                            fill: "none",
                                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                                                d: "M4 8L12 16L20 8",
                                                                                stroke: "currentColor",
                                                                                "stroke-width": "3.5",
                                                                                "stroke-linecap": "round",
                                                                                "stroke-linejoin": "round"
                                                                            })
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "mobile-pages ".concat(activeMenu === "support" ? "open" : ""),
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                            href: "/contato",
                                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                                className: "white",
                                                                                children: "Contato"
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                                                className: "white",
                                                                                children: [
                                                                                    "Hor\xe1rio de Funcionamento ",
                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                                                        style: {
                                                                                            cursor: "pointer"
                                                                                        },
                                                                                        className: "bi bi-caret-down-fill px-1 ".concat(active ? "rotate-on-click" : ""),
                                                                                        onClick: showHours
                                                                                    })
                                                                                ]
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                            className: "horario-dropdown ".concat(active ? "open" : ""),
                                                                            children: businessHours.map((hour, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                                    className: "horario-item",
                                                                                    style: {
                                                                                        animationDelay: "".concat(index * 0.15, "s")
                                                                                    },
                                                                                    children: [
                                                                                        hour.name,
                                                                                        ": ",
                                                                                        hour.openingTime,
                                                                                        " - ",
                                                                                        hour.closingTime
                                                                                    ]
                                                                                }, index))
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "border-sm col-lg-3 col-sm-12 col-xxs-12 d-flex justify-content-center",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "quick-links",
                                                    style: {
                                                        alignItems: "center !important"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "d-flex justify-content-center align-items-center gap-2",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "quick-link-icon",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                                        className: "flaticon-email"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                    className: "mb-0 white",
                                                                    children: "FALE CONOSCO"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            className: "text-center",
                                                            children: "Estamos prontos para te ajudar!"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "btn btn-secondary btn-md d-block btn-black col-lg-6",
                                                            style: {
                                                                marginBottom: "10px"
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {}),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                    href: "/contato",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                        className: "white",
                                                                        children: "Entrar em Contato"
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "footer-copyright footer-copyright-margin-top",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "container",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "row align-items-center",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "col-sm-7",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "copyright-text",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                className: "mb-0",
                                                children: [
                                                    "\xa9 Todos os direitos reservados! Desenvolvido por \xa0\xa0",
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                        href: "https://bndv.com.br",
                                                        target: "_blank",
                                                        rel: "noreferrer",
                                                        children: "BNDV - Banco Nacional de Ve\xedculos"
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "col-sm-5",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "copyright-links text-start text-sm-end mt-1 mt-sm-0",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                href: "/termos",
                                                children: "Termo de Uso e Pol\xedtica de Privacidade"
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        })
    });
}


/***/ }),

/***/ 392:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Header; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var _services_api__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8382);




function Header(param) {
    let { company  } = param;
    const [activePages, setActivePages] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]);
    const [isMenuOpen, setIsMenuOpen] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        const pages = [];
        (0,_services_api__WEBPACK_IMPORTED_MODULE_3__/* .fetchGetCompanySiteSettings */ .XQ)().then((res)=>{
            pages.push({
                route: "",
                name: "Home"
            });
            res.showNew === true ? pages.push({
                route: "novos",
                name: "0 Km"
            }) : null;
            res.showUsed === true ? pages.push({
                route: "seminovos",
                name: "Seminovos"
            }) : null;
            res.showArmored === true ? pages.push({
                route: "blindados",
                name: "Blindados"
            }) : null;
            pages.push({
                route: "sobre-nos",
                name: "Sobre"
            });
            res.showFinancing === true ? pages.push({
                route: "financiamento",
                name: "Financiamento"
            }) : null;
            res.showVehiclePurchase === true ? pages.push({
                route: "venda-seu-veiculo",
                name: "Venda seu Ve\xedculo"
            }) : null;
            res.showInsurance === true ? pages.push({
                route: "seguro",
                name: "Seguro"
            }) : null;
            pages.push({
                route: "contato",
                name: "Contato"
            });
            setActivePages(pages);
        });
    }, []);
    const toggleMenu = ()=>{
        setIsMenuOpen(!isMenuOpen);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("header", {
                className: "header-style-one header-sticky",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "col-lg-12",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    href: "/",
                                    children: company.logo ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                        src: company.logo,
                                        alt: "logo",
                                        width: 240,
                                        height: 64,
                                        sizes: "100vw",
                                        quality: 100,
                                        loading: "lazy",
                                        style: {
                                            marginTop: "10px",
                                            marginBottom: "4px"
                                        }
                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {})
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "spinner-master ".concat(isMenuOpen ? "active" : ""),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                        onClick: toggleMenu,
                                        className: "mobile-menu-toggle header-toggle-btn ms-4 d-lg-none",
                                        "aria-label": "Abrir Menu",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "spinner-spin",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    className: "spinner diagonal part-1"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    className: "spinner horizontal"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    className: "spinner diagonal part-2"
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "col-lg-12",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: " d-flex align-items-center justify-content-around",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("nav", {
                                className: "at_nav_menu d-none d-lg-block",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                    children: activePages.map((page, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                href: "/".concat(page.route),
                                                children: page.name
                                            })
                                        }, index))
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mobile-menu position-fixed bg-black deep-shadow ".concat(isMenuOpen ? "active" : null),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("nav", {
                    className: "mobile-menu-wrapper",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                        children: activePages.map((page, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    href: "/".concat(page.route),
                                    children: page.name
                                })
                            }, index))
                    })
                })
            })
        ]
    });
}


/***/ })

}]);